module.exports = __webpack_public_path__ + "static/media/TERMO_DE_CONVENIO_PREFEITURA_DE_MACEIO.63837a23.pdf";